export function getParam(name, url) {
  let src = url || window.location.href
  if (name && src) {
    var r = new RegExp("(\\?|#|&|^)" + name + "=([^&^#]*)(#|&|$)")
    var m = src.match(r)
    return !m ? "" : decodeURIComponent(m[2])
  }
  return ""
}

export function delParam(name, url) {
  if (!(name instanceof Array)) {
    name = [name]
  }

  name.forEach(function(v) {
    url = url.replace(new RegExp("(?:&" + v + "=[^&]*)", "g"), "")
    url = url.replace(new RegExp("(?:\\?" + v + "=[^&]*&?)", "g"), "?")
  })
  return url
}

// 获取字符串的参数列表
export function getStrParams(str, decode) {
  var _paramArray = str.split("&")
  var params = {}

  for (var _idx in _paramArray) {
    if (Object.prototype.hasOwnProperty.call(_paramArray, _idx)) {
      var row = _paramArray[_idx]
      var splitIdx = row.indexOf("=")
      if (splitIdx > 0) {
        var key = row.substring(0, splitIdx)
        var value = row.substring(splitIdx + 1)
        if (decode) {
          try {
            value = decodeURIComponent(value)
          } catch (e) {
            value = ""
          }
        }
        params[key] = value
      }
    }
  }
  return params
}

export function getBase64(url, outputFormat = "image/png", catchError = false) {
  // 如果地址是http地址，则转为base64，如果已经是base64则无需转换
  return new Promise((resolve, reject) => {
    if (url.indexOf("base64") > -1) {
      resolve(url)
    } else {
      try {
        let canvas = document.createElement("canvas"),
          ctx = canvas.getContext("2d"),
          img = new Image()

        img.crossOrigin = "Anonymous"
        img.onload = () => {
          canvas.height = img.height
          canvas.width = img.width
          ctx?.drawImage(img, 0, 0)
          let dataURL = canvas.toDataURL(outputFormat)
          canvas = null
          resolve(dataURL)
        }
        img.onerror = error => {
          catchError ? reject(error) : resolve(error)
        }

        img.src = `${url}?t=${+new Date()}`
      } catch (error) {
        catchError ? reject(error) : resolve(error)
      }
    }
  })
}
